import Vue from "vue";
import Router from "vue-router";
import findLast from "lodash/findLast";
import { notification } from "ant-design-vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { check } from "./utils/auth";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/user",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "layout" */ "@/layouts/UserLayout"),
      children: [
        {
          path: "/user",
          redirect: "/user/login"
        },
        {
          path: "/user/login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/User/Login")
        },
        {
          path: "/user/register",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "user" */ "@/views/User/Register")
        }
      ]
    },
    {
      path: "/",
      meta: { authority: ["user", "admin"] },
      component: () =>
        import(/* webpackChunkName: "layout" */ "@/layouts/BasicLayout"),
      children: [
        // dashboard
        {
          path: "/",
          redirect: "/dashboard/analysis"
        },
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {
            icon: "dashboard",
            title: "仪表盘",
            authority: ["user", "admin"]
          },
          component: { render: h => h("router-view") },
          children: [
            {
              path: "/dashboard/analysis",
              name: "analysis",
              meta: { title: "分析页" },
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Analysis")
            }
          ]
        },
        {
          path: "/article",
          name: "article",
          component: { render: h => h("router-view") },
          redirect: "/article/created",
          meta: {
            title: "文章管理",
            icon: "file-text",
            authority: ["user", "admin"]
          },
          children: [
            {
              path: "/article/created",
              name: "articlecreated",
              component: () =>
                import(/* webpackChunkName: "article" */ "@/views/Article/Created"),
              meta: { title: "发布文章" }
            },
            {
              path: "/article/list",
              name: "articlelist",
              component: () =>
                import(/* webpackChunkName: "article" */ "@/views/Article/List"),
              meta: { title: "文章列表" }
            }
          ]
        },
        {
          path: "/hao",
          name: "hao",
          component: { render: h => h("router-view") },
          redirect: "/hao/onsale",
          // eslint-disable-next-line prettier/prettier
          meta: {
            icon: "gold",
            title: "号码管理",
            authority: ["user", "admin"]
          },
          children: [
            {
              path: "/hao/upload",
              name: "haoupload",
              meta: { title: "更新号码" },
              component: () =>
                import(/* webpackChunkName: "hao" */ "@/views/Hao/Upload")
            },
            {
              path: "/hao/onsale",
              name: "haoonsale",
              meta: { title: "出售中的号" },
              component: () =>
                import(/* webpackChunkName: "hao" */ "@/views/Hao/Onsale")
            },
            {
              path: "/hao/stock",
              name: "haostock",
              component: () =>
                import(/* webpackChunkName: "hao" */ "@/views/Hao/Stock"),
              meta: { title: "仓库中的号" }
            }
          ]
        },
        {
          path: "/usersetting",
          name: "usersetting",
          component: { render: h => h("router-view") },
          redirect: "/usersetting/userinfo",
          meta: {
            title: "设置",
            icon: "setting",
            authority: ["user", "admin"]
          },
          children: [
            {
              path: "/usersetting/siteinfo",
              name: "usersettingsiteinfo",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/SiteInfo"),
              meta: { title: "网站设置" }
            },
            {
              path: "/usersetting/shopinfo",
              name: "usersettingshopinfo",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/ShopInfo"),
              meta: { title: "店铺设置" }
            },
            {
              path: "/usersetting/menuinfo",
              name: "usersettingmenuinfo",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/MenuInfo"),
              meta: { title: "菜单设置-未好" }
            },
            {
              path: "/usersetting/articletype",
              name: "usersettingarticletype",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/ArticleType"),
              meta: { title: "文章分类-未好" }
            },
            {
              path: "/usersetting/haodesc",
              name: "usersettinghaodesc",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/HaoDesc"),
              meta: { title: "号码描述" }
            },
            {
              path: "/usersetting/footerinfo",
              name: "usersettingfooterinfo",
              component: () =>
                import(/* webpackChunkName: "setting" */ "@/views/UserSetting/FooterInfo"),
              meta: { title: "底部描述" }
            }
          ]
        }
      ]
    },
    {
      path: "/403",
      name: "403",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "exception" */ "@/views/Exception/403")
    },
    {
      path: "*",
      name: "404",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "exception" */ "@/views/Exception/404")
    }
  ]
});
function getSS() {
  if (store.getters.getAuthority.length > 0) {
    return store.getters.getAuthority;
  }
  const _ss = Vue.ls.get("SS");
  const userinfo = Vue.ls.get("INFO");
  if (_ss && userinfo) {
    if (userinfo.user_level === "超级管理员") {
      store.commit("setAuthority", "admin");
      return ["admin"];
    } else if (userinfo.user_level === "供货商") {
      store.commit("setAuthority", "user");
      return ["user"];
    }
    return ["guest"];
  } else {
    return ["guest"];
  }
}
//const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }
  const record = findLast(to.matched, record => record.meta.authority);
  const _auth = getSS();
  if (record && !check(_auth, record.meta.authority)) {
    if (to.path !== "/user/login") {
      next({
        path: "/user/login"
      });
    } else if (to.path !== "/403") {
      notification.error({
        message: "403",
        description: "你没有权限访问，请联系管理员咨询。"
      });
      next({
        path: "/403"
      });
    }
    NProgress.done();
  }
  next();
});
router.afterEach(() => {
  NProgress.done();
});

export default router;
